module.exports = require("./../../_gen/openfl/errors/ArgumentError");